import { render, staticRenderFns } from "./CustomerPhoneEmail.vue?vue&type=template&id=4f55af20"
import script from "./CustomerPhoneEmail.vue?vue&type=script&lang=js"
export * from "./CustomerPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports